import * as bigInt from 'big-integer';

export class TimeHelpers {

    static convert64bitTimestampToDate = (high: number, low: number): Date => {
        const shiftLeft32 = bigInt("4294967296");
        const SEC_TO_UNIX_EPOCH = bigInt("11644473600");
        const WINDOWS_TICK = bigInt("10000000");
        const lowPartBigInt = bigInt(low);
        const highPartBigInt = bigInt(high);
        let time = highPartBigInt.multiply(shiftLeft32);
        time = time.add(lowPartBigInt);
        time = time.divide(WINDOWS_TICK);
        time = time.subtract(SEC_TO_UNIX_EPOCH);
        const dateInMs = time.valueOf() * 1000;
        const date = new Date(dateInMs);
        return date;
    }

    static getTimestamp = () => Date.now();
}